export default "__VITE_ASSET__Pcbp8M33__";